export const BALLERINE_EVENT = 'blrn_event';
